module.exports = __webpack_public_path__ + "img/qatar.20810d36.webp";